import React, { Component } from 'react';
import Session from './Session';
import logo from './logo.svg';
import * as Sentry from '@sentry/browser';

Sentry.init({
    dsn: 'https://392bab0b3c194a3387cff9eafa3d8f6f@sentry.io/1728029'
});

const requestPictureInPictureSupport = (document as any).createElement('video')
    .requestPictureInPicture;

const browserApis = {
    getUserMedia: navigator.mediaDevices && navigator.mediaDevices.getUserMedia,
    getDisplayMedia:
        navigator.mediaDevices &&
        (navigator as any).mediaDevices.getDisplayMedia,
    pictureInPicture:
        'pictureInPictureEnabled' in document &&
        (document as any).pictureInPictureEnabled &&
        requestPictureInPictureSupport
};

const browserSupports = Object.values(browserApis).every(
    val => Boolean(val) === true
);

const NoSupportMessage = ({ apis }: any) => (
    <div className="no-support">
        <h2>Unfortunately, your browser does not support SeaState.</h2>
        <p>
            As well as being a useful user testing tool, SeaState is an
            experiment in using the latest browser technologies.
            <br />
            At the time of writing only{' '}
            <a href="https://www.google.com/chrome/" rel="nofollow">
                Google Chrome
            </a>{' '}
            supports all the required features.
        </p>

        <div className="technical-support-notes">
            <h3>Technical notes</h3>
            <p>
                The following APIs need to be supported by your browser for
                SeaState to work
            </p>
            <ul>
                {Object.entries(apis).map(([api, support], index) => {
                    return (
                        <li key={index}>
                            {support ? (
                                <span className="supported">✓</span>
                            ) : (
                                <span className="not-supported">✗</span>
                            )}

                            <a href={`https://caniuse.com/#search=${api}`}>
                                {api}
                            </a>
                        </li>
                    );
                })}
            </ul>
        </div>
    </div>
);

class App extends Component {
    render() {
        return (
            <div className="app">
                <div className="masthead">
                    <div className="constrain">
                        <img src={logo} />
                    </div>
                </div>
                <div className="content">
                    <div className="constrain">
                        {!browserSupports && (
                            <NoSupportMessage apis={browserApis} />
                        )}
                        {browserSupports && <Session />}
                    </div>
                </div>
                <div className="footer">
                    Another 🌊 by{' '}
                    <a href="https://wemakewaves.digital">We Make Waves</a>
                </div>
            </div>
        );
    }
}

export default App;
